import type { ComboBoxOptions } from "@dealer-center/core-components";
import { useState } from "react";
import type { useSearchFilterHookStates } from "./internal";

export const useSearchFilterHook = (): useSearchFilterHookStates => {
  const [accountTypesValue, setAccountTypesValue] = useState<ComboBoxOptions>(
    []
  );
  const [urlValue, setSelectedUrlValue] = useState<ComboBoxOptions>([]);
  const [statusValue, setStatusValue] = useState<ComboBoxOptions>([]);
  const [dateAfterValue, setDateAfterValue] = useState<Date | undefined>(
    undefined
  );
  const [dateBeforeValue, setDateBeforeValue] = useState<Date | undefined>(
    undefined
  );
  const [countryValue, setSelectedCountryValue] = useState<ComboBoxOptions>([]);
  const [franchisesMatchAllValue, setFranchisesMatchAllValue] =
    useState<ComboBoxOptions>([]);
  const [franchisesMatchAnyValue, setFranchisesMatchAnyValue] =
    useState<ComboBoxOptions>([]);
  const [franchisesMatchNoneValue, setFranchisesMatchNoneValue] =
    useState<ComboBoxOptions>([]);
  const [controlCenterPlatformsValue, setControlCenterPlatformsValue] =
    useState<ComboBoxOptions>([]);
  const [stateValue, setSelectedStateValue] = useState<ComboBoxOptions>([]);
  const [dealerCodesValueMatchAll, setDealerCodesValueMatchAll] =
    useState<ComboBoxOptions>([]);
  const [dealerCodesMatchAll, setDealerCodesMatchAll] =
    useState<ComboBoxOptions>([]);
  const [resourcesMatchAllValue, setResourcesMatchAllValue] =
    useState<ComboBoxOptions>([]);
  const [resourcesMatchAnyValue, setResourcesMatchAnyValue] =
    useState<ComboBoxOptions>([]);
  const [resourcesMatchNoneValue, setResourcesMatchNoneValue] =
    useState<ComboBoxOptions>([]);
  const [postalCodeValue, setPostalCodeValue] = useState<ComboBoxOptions>([]);
  const [nameValue, setNameValue] = useState<ComboBoxOptions>([]);
  const [verticalTypesValue, setVerticalTypesValue] = useState<ComboBoxOptions>(
    []
  );
  const [idValue, setIdValue] = useState<ComboBoxOptions>([]);
  return {
    accountTypesValue,
    setAccountTypesValue,
    urlValue,
    setSelectedUrlValue,
    statusValue,
    setStatusValue,
    dateAfterValue,
    setDateAfterValue,
    dateBeforeValue,
    setDateBeforeValue,
    countryValue,
    setSelectedCountryValue,
    franchisesMatchAllValue,
    setFranchisesMatchAllValue,
    franchisesMatchAnyValue,
    setFranchisesMatchAnyValue,
    franchisesMatchNoneValue,
    setFranchisesMatchNoneValue,
    controlCenterPlatformsValue,
    setControlCenterPlatformsValue,
    stateValue,
    setSelectedStateValue,
    dealerCodesValueMatchAll,
    setDealerCodesValueMatchAll,
    dealerCodesMatchAll,
    setDealerCodesMatchAll,
    resourcesMatchAllValue,
    setResourcesMatchAllValue,
    resourcesMatchAnyValue,
    setResourcesMatchAnyValue,
    resourcesMatchNoneValue,
    setResourcesMatchNoneValue,
    postalCodeValue,
    setPostalCodeValue,
    nameValue,
    setNameValue,
    verticalTypesValue,
    setVerticalTypesValue,
    idValue,
    setIdValue
  };
};
